import {useSelector, useDispatch} from 'react-redux';
import Modal from 'react-modal';
import {Translate} from 'react-redux-i18n';

import {Icon} from 'front-onceforall-core';

import PropTypes from 'prop-types';
import {toggleModal} from '../../actions/modals';

function AccessBdrErrorModal({text1Key, text2Key, text3Key}) {
  const dispatch = useDispatch();
  const [showModal] = useSelector(globalState => ([
    globalState.modals.accessBdrErrorModal
  ]));

  function closeModal() {
    dispatch(toggleModal('accessBdrErrorModal', false));
  }

  return (
    <Modal
      defaultStyles={{
        overlay: {
          backgroundColor: 'rgba(255,255,255,0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1
        },
        content: {
          backgroundColor: '#fff',
          borderRadius: 4,
          boxShadow: 'rgba(0, 0, 0, 0.35) 0px 0px 32px 0px',
          minWidth: 300,
          maxWidth: 700,
          outline: 0,
          position: 'relative'
        }
      }}
      isOpen={showModal}
      onRequestClose={closeModal}
      ariaHideApp
      shouldCloseOnOverlayClick
    >
      <div className='p-4'>
        <div className='p-4 d-flex flex-column justify-content-center align-items-start'>
          <Translate
            className="my-2"
            value={text1Key}
          />
          <Translate
            className="my-2"
            dangerousHTML
            value={text2Key}
          />
          <Translate
            className="my-2"
            value={text3Key}
          />
        </div>
        <div className="d-flex flex-row justify-content-end align-items-center">
          <button
            type="button"
            className="large secondary inline-container"
            onClick={closeModal}
            data-id="cancel"
          >
            <Icon icon="go-back"/>
          </button>
        </div>

      </div>
    </Modal>
  );
}

AccessBdrErrorModal.propTypes = {
  text1Key: PropTypes.string.isRequired,
  text2Key: PropTypes.string.isRequired,
  text3Key: PropTypes.string.isRequired
};

export default AccessBdrErrorModal;
